import {
  CheckListsProvider,
  useChecklistsContext,
} from "src/components/pages/Settings/Miscellaneous/CheckLists/CheckListsContext";
import CheckListsHeader from "src/components/pages/Settings/Miscellaneous/CheckLists/CheckListsHeader";
import CheckListTable from "src/components/pages/Settings/Miscellaneous/CheckLists/CheckListTable/CheckListTable";
import { PageContainer } from "src/styled";

import styles from "./ChecklistLogbook.module.scss";

const ChecklistLogbook = () => {
  return (
    <CheckListsProvider>
      <PageContainer className={styles.page}>
        <div className={styles.content}>
          <CheckListsHeader />
          <CheckListTable />
        </div>
      </PageContainer>
    </CheckListsProvider>
  );
};

export default ChecklistLogbook;
